import {memo} from 'react'

import {BUTTON_BOX_SIZE, BUTTON_VARIANT, ButtonBox} from '@defign/ui'
import classNames from 'classnames/bind'

import styles from './GraphModal.module.scss'

const cx = classNames.bind(styles)

function GraphModal({onClick}: {onClick: () => void}) {
    return (
        <div className={cx('article')}>
            <h3 className={cx('title')}>보장금액 기준</h3>
            <p className={cx('description')}>보장금액은 각 보장의 가장 대표적인 보장항목 기준으로 보여드려요.</p>
            <dl className={cx('list')}>
                <div className={cx('item')}>
                    <dt className={cx('key')}>실손</dt>
                    <dd>질병 입원</dd>
                </div>
                <div className={cx('item')}>
                    <dt className={cx('key')}>암</dt>
                    <dd>일반암 진단비</dd>
                </div>
                <div className={cx('item')}>
                    <dt className={cx('key')}>뇌</dt>
                    <dd>뇌출혈 진단비</dd>
                </div>
                <div className={cx('item')}>
                    <dt className={cx('key')}>심장</dt>
                    <dd>급성심근경색 진단비</dd>
                </div>
                <div className={cx('item')}>
                    <dt className={cx('key')}>사망</dt>
                    <dd>질병 사망</dd>
                </div>
                <div className={cx('item')}>
                    <dt className={cx('key')}>입원</dt>
                    <dd>질병 입원 (4일 이상)</dd>
                </div>
                <div className={cx('item')}>
                    <dt className={cx('key')}>후유장해</dt>
                    <dd>재해 장해 79%</dd>
                </div>
            </dl>
            <div className={cx('button')}>
                <ButtonBox
                    size={BUTTON_BOX_SIZE.LARGE_FULL}
                    variant={BUTTON_VARIANT.TERTIARY}
                    text="확인"
                    onClick={onClick}
                />
            </div>
        </div>
    )
}

export default memo(GraphModal)
